import SpecialDayOffAdminReportHeader from "../../components/SpecialDayOffAdminReport/SpecialDayOffAdminReportHeader";
import SpecialDayOffAdminReportStats from "../../components/SpecialDayOffAdminReport/SpecialDayOffAdminReportStats";
import SdoAdminReportInfo from '../../components/SpecialDayOffAdminReport/SdoAdminReportInfo';
import SdoAdminTabs from "../../components/SpecialDayOffAdminReport/SdoAdminTabs";
import "./SdoAdminReports.scss";
import { useEffect, useState } from "react";
import { useSdoAdminReportsProvider } from "../../providers/SdoAdminReportsProvider";
import Loader from "../../components/Loader/Loader";

export default function SdoAdminReports() {
  const [tabValue, setTabValue] = useState(0);
  const sdoAdminReportsContext = useSdoAdminReportsProvider();
  const [sdoMonthYear, setSdoMonthYear] = useState<any>({
    sdoMonth: '',
    sdoYear: '',
    sdoMonthYearString: ''
  });

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
    sdoAdminReportsContext.setSdoUsageReportsLoading(true);
  }

  useEffect(() => {
    sdoAdminReportsContext.getSdoUsageListData();
    sdoAdminReportsContext.getSdoCurrentSubPeriodData();
    sdoAdminReportsContext.getSdoMonthlyListData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!sdoAdminReportsContext?.sdoCurrentSubPeriodData?.month) return;

    setSdoMonthYear({
      sdoMonth: sdoAdminReportsContext?.sdoCurrentSubPeriodData?.month,
      sdoYear: sdoAdminReportsContext?.sdoCurrentSubPeriodData?.year,
    });

  }, [sdoAdminReportsContext.sdoCurrentSubPeriodData]);

  useEffect(() => {
    if (sdoMonthYear.sdoMonth && sdoMonthYear.sdoYear) {
      sdoAdminReportsContext.getPositionsPublishData(sdoMonthYear);
      sdoAdminReportsContext.getSdoUsageReportsData({ year: sdoMonthYear.sdoYear });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sdoMonthYear.sdoMonth,sdoMonthYear.sdoYear]);

  return (
    sdoAdminReportsContext.sdoUsageListLoading || sdoAdminReportsContext.sdoMonthlyListLoading || sdoAdminReportsContext.positionsPublishLoading || sdoAdminReportsContext.sdoCurrentSubPeriodLoading ? <Loader /> : (
      <div className="sdo-admin-reports__container">
        <SpecialDayOffAdminReportHeader />
        <SpecialDayOffAdminReportStats />
        <SdoAdminReportInfo />
        <SdoAdminTabs tabValue={tabValue} handleTabChange={handleTabChange}/>
      </div>
    )
  );
}
